import styled, { css, keyframes } from 'styled-components';
import COLORS from '../../utils/Colors';
import { NAVBAR_HEIGHT } from '../../utils/constants';

interface SelectedServicesProps {
    totalItems: number;
}

interface ServiceItemProps {
    isSelected: boolean;
}

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: ${NAVBAR_HEIGHT};
`;

export const Container = styled.div`
    display: flex;
    width: 60vw;
    justify-content: center;
    flex-direction: column;
    padding-bottom: 2rem;

    @media (max-width: ${({ theme }) => theme.screenSizes.laptopL}) {
        width: 75vw;
    };

    @media (max-width: ${({ theme }) => theme.screenSizes.laptop}) {
        width: 85vw;
    };

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        width: 95vw;
    };

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        width: 100vw;
        padding-bottom: 100px; /* Space for fixed bottom bar */
    };
`;

export const Content = styled.div`
    flex: 1;
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    padding-bottom: 3rem;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        & > div {
            &:nth-child(1) {
                margin: 0 1.5rem;
                order: 2;
                padding-top: 1.5rem;
            }
            &:nth-child(2) {
                padding: 0 1.5rem 1.5rem 1.5rem;
                margin-top: 1rem;
                border-bottom: 1px solid ${COLORS.rgba204204204050};
                order: 3;
            }
            &:nth-child(3) {
                order: 1;
                margin: 0;
            }
            &:nth-child(4) {
                padding: 1.5rem;
                order: 4;
            }
        }
    };
`;

export const FirstRow = styled.div`
`;

export const Title = styled.h1`
    font-family: 'Raleway', sans-serif;
    font-size: 1.5em;
    margin: 0;
    font-weight: 700;
`;

export const SecondRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding-bottom: 1rem;
    margin-top: 0.5rem;

    & div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    
    & p {
        font-size: 0.9em;
        font-weight: 500;
        margin-left: 0.6rem;
    }

    & p:nth-child(2) {
        margin-left: 0.3rem;
    }

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
       flex-direction: column;
    };
`;

export const ActionBtn = styled.div`
    margin-left: 1em;
    padding: 0.5rem;
    cursor: pointer;
    border-radius: 8px;

    &:hover {
        background-color: ${COLORS.white2};
    }
`;

export const LocationInfo = styled.p`
    color: ${COLORS.black};
    margin: 0;
    text-decoration: underline;
    cursor: pointer;
`;

export const CommentsText = styled.p`
    color: ${COLORS.black};
    margin: 0;
    text-decoration: underline;
    cursor: pointer;
`;

export const ScoreText = styled.p`
    font-weight: bold;
    color: ${COLORS.black};
    margin: 0;
    border-radius: 8px;
`;

export const BottomSection = styled.div`
    display: grid;
    padding-top: 4rem;

    @media (min-width: ${({ theme }) => theme.screenSizes.laptop}) {
        grid-template-columns: 65% 35%;
    };
`;

export const ServicesContainer = styled.div`
    display: flex;
    flex-direction: column;

    @media (min-width: ${({ theme }) => theme.screenSizes.tablet}) {
        margin-right: 5rem;
    };
`;

export const ServiceItem = styled.div<ServiceItemProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 0;
    margin-top: 2px;
    border-bottom: 1px solid ${COLORS.rgba204204204050};
    border-left: ${props => props.isSelected ? `5px solid ${COLORS.mainTeal}` : 'none'};
    cursor: pointer;

    & div {
        margin-left: 0.5rem;
    }

    & div :first-child {
      align-items: center;
    }

    &:last-child {
        border-bottom: 0;
    }
`;

export const ServiceName = styled.p`
    margin: 0;
    margin-right: 1.5rem;
    font-size: 1.2rem;
`;

export const ServiceDescription = styled.p`
    margin: 0;
    margin-top: 0.5rem;
    font-size: 0.8rem;
    color: ${COLORS.hsl210004055};
`;

export const ServicePrice = styled.p<{ isVariable?: boolean }>`
    align-self: center;
    margin-right: 3rem;
    color: ${props => props.isVariable ? '#7c3aed' : 'inherit'};
    font-style: ${props => props.isVariable ? 'italic' : 'normal'};
    font-size: ${props => props.isVariable ? '0.9rem' : 'inherit'};
`;

// BOOK SECTION
export const BookingSection = styled.div`
    
`;

export const BillingSummary = styled.div`
    display: flex;
    justify-content: space-between;
    margin-top: 2.2rem;
    margin-bottom: 1rem;

    & p {
        font-size: 1.2rem;
    }
    
    & p:first-child {
        font-family: 'Raleway', sans-serif;
    }
`;

export const BookBox = styled.div`
    position: sticky;
    top: 2rem;
    min-height: 15rem;
    flex-direction: column;
    border-radius: 12px;
    padding: 1rem 1.5rem;
    border: 1px solid ${COLORS.rgba204204204050};
    box-shadow: 0px 10px 15px 5px rgba(0, 0, 0, 0.1); // regular box shadow

    & div {
        flex: 1;
    }
           
    display: none;
    @media (min-width: ${({ theme }) => theme.screenSizes.laptop}) {
        display: flex;
    };
`;

export const BookBtn = styled.button`
    width: 100%;
    background-color: ${COLORS.mainTeal};
    padding: 1rem;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    transition: 225ms ease-in-out;
    
    &:hover {
        background-color: ${COLORS.mainTealDark};
        transform: translateY(-2px);
    }

    & p {
        font-family: 'Raleway', sans-serif;
        color: ${COLORS.white};
        font-size: 1.3rem;
        font-weight: 500;
    }
`;

export const BottomBookBox = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${COLORS.white};
    border-top: 1px solid ${COLORS.freshaGray200};
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
    padding: 12px 16px;
    padding-bottom: max(12px, env(safe-area-inset-bottom));
    z-index: 100;

    @media (min-width: ${({ theme }) => theme.screenSizes.laptop}) {
        display: none;
    }
`;

export const BottomBarContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const BottomBarServices = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    flex: 1;
    min-width: 0;
`;

export const BottomBarPrice = styled.span`
    font-size: 1.125rem;
    font-weight: 600;
    color: ${COLORS.freshaGray900};
    white-space: nowrap;
`;

export const BottomBookBtn = styled.button<{ fullWidth?: boolean }>`
    background-color: ${COLORS.mainTeal};
    padding: 1rem;
    border: 0;
    border-radius: 12px;
    cursor: pointer;
    margin-right: ${props => props.fullWidth ? '0' : '1.5rem'};
    ${props => props.fullWidth && 'flex: 1;'}

    &:hover {
        background-color: ${COLORS.mainTealDark};
    }

    & p {
        font-family: 'Raleway', sans-serif;
        color: ${COLORS.white};
        font-size: 1rem;
        font-weight: 500;
    }
`;

export const WarningText = styled.p`
    text-align: center;
    margin-top: 0.8rem;
    color: ${COLORS.hsl210003050};
    font-size: 0.8rem;
`;

export const TotalPriceText = styled.p`
    color: ${COLORS.black};
    font-size: 1.5rem;
    font-weight: 300;
    margin-left: 1.5rem;
`;

// SELECTED SERVICES
export const SelectedServicesContainer = styled.div<SelectedServicesProps>`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: ${props => props.totalItems > 0 ? '12px 0' : '0'};
`;

export const SeparatorLine = styled.div`
    height: 5px;
    border-bottom: 1px solid ${COLORS.rgba204204204050};

    @media (max-width: ${({ theme }) => theme.screenSizes.laptop}) {
        width: 100%;
    };
`;

// REVIEWS SECTION
export const ReviewsSection = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    margin: 3rem 0;
    padding-bottom: 50px;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        margin: 3rem 1.5rem;
        padding-bottom: 100px;
    };
`;

export const ReviewsFirstRow = styled.div`
    margin-bottom: 1.2em;
    display: flex;
    flex-direction: row;

    & p {
        font-size: 1.5em;
        margin: 0 0.7rem;
    }

    @media (min-width: ${({ theme }) => '1300px'}) {
        /* margin: 0 0 1.2rem 0; */
    };
`;

export const ReviewsSecondRow = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;

    @media (min-width: ${({ theme }) => theme.screenSizes.laptop}) {
        width: 50%;
    };
`;

export const ReviewsCommentsText = styled.p`
    color: ${COLORS.black};
    margin: 0;
`;

export const About = styled.div`
    padding-top: 1.5rem;

    & p {
        font-size: 1rem;
        line-height: 1.6rem;
    }
`;

// Section header for visual hierarchy
export const SectionHeader = styled.h2`
    font-family: 'Raleway', sans-serif;
    font-size: 1.25rem;
    font-weight: 700;
    color: ${COLORS.black};
    margin: 0 0 0.75rem 0;
    padding-bottom: 0.5rem;
`;

// About section (moved above reviews)
export const AboutSection = styled.div`
    padding: 1.5rem 0 0.5rem;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        padding: 1.5rem 1.5rem 0.5rem;
    }
`;

export const AboutText = styled.p`
    font-size: 1rem;
    line-height: 1.6;
    color: ${COLORS.hsl210004055};
    margin: 0;
`;

// Tattoo shop CTA section
export const TattooCTASection = styled.div`
    display: none;
    flex-direction: column;
    align-items: center;
    padding: 3rem 1.5rem;
    text-align: center;

    @media (min-width: ${({ theme }) => theme.screenSizes.laptop}) {
        display: flex;
    }
`;

export const TattooCTAButton = styled.button`
    width: 100%;
    max-width: 400px;
    background-color: ${COLORS.mainTeal};
    color: ${COLORS.white};
    font-family: 'Raleway', sans-serif;
    font-size: 1.25rem;
    font-weight: 600;
    padding: 1rem 2rem;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    transition: all 200ms ease;

    &:hover {
        background-color: ${COLORS.mainTealDark};
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(13, 148, 136, 0.3);
    }

    &:active {
        transform: translateY(0);
    }
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full viewport height */
`;

export const Spinner = styled.div`
  border: 8px solid rgba(0, 0, 0, 0.1);
  border-top: 8px solid #3498db; /* Blue color */
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: ${spin} 1s linear infinite;
`;

// HERO GALLERY - For businesses WITH images (Fresha-style)
export const HeroGalleryContainer = styled.div`
    display: grid;
    grid-template-columns: 65% 35%;
    gap: 8px;
    height: 400px;
    border-radius: 16px;
    overflow: hidden;

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        grid-template-columns: 1fr;
        height: auto;
    }
`;

export const HeroMainImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;

    @media (min-width: ${({ theme }) => theme.screenSizes.tablet}) {
        border-radius: 16px 0 0 16px;
    }

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        border-radius: 16px;
        height: 250px;
    }
`;

export const HeroThumbnailContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        display: none;
    }
`;

export const HeroThumbnail = styled.div`
    position: relative;
    flex: 1;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    &:first-child img {
        border-radius: 0 16px 0 0;
    }

    &:last-child img {
        border-radius: 0 0 16px 0;
    }

    &:only-child img {
        border-radius: 0 16px 16px 0;
    }
`;

export const SeeAllImagesButton = styled.button`
    position: absolute;
    bottom: 16px;
    right: 16px;
    background: ${COLORS.white};
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.85rem;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: transform 0.2s ease;

    &:hover {
        transform: scale(1.02);
    }
`;

// GRADIENT HEADER - For businesses WITHOUT images
export const GradientHeader = styled.div`
    background: linear-gradient(135deg, ${COLORS.mainTeal} 0%, ${COLORS.mainTealLight} 100%);
    padding: 3rem 2rem;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        padding: 2rem 1.5rem;
        margin: 0 -1rem;
        border-radius: 0;
    }
`;

export const BusinessInitialCircle = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: ${COLORS.white};
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2rem;
    font-weight: 700;
    color: ${COLORS.mainTeal};
    margin-bottom: 1rem;
    font-family: 'Raleway', sans-serif;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        width: 60px;
        height: 60px;
        font-size: 1.5rem;
    }
`;

export const GradientTitle = styled.h1`
    color: ${COLORS.white};
    font-family: 'Raleway', sans-serif;
    font-size: 1.8rem;
    margin: 0 0 0.5rem 0;
    font-weight: 700;

    @media (max-width: ${({ theme }) => theme.screenSizes.mobileL}) {
        font-size: 1.4rem;
    }
`;

export const GradientSubtitle = styled.div`
    color: rgba(255, 255, 255, 0.95);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    font-size: 0.95rem;
    flex-wrap: wrap;

    svg {
        fill: ${COLORS.white};
    }

    span {
        color: rgba(255, 255, 255, 0.95);
    }
`;

// Image Gallery Components
export const ImageGrid = styled.div<{ count: number }>`
    position: relative;
    display: grid;
    gap: 8px;
    height: clamp(280px, 42vw, 520px);
    border-radius: 16px;
    overflow: hidden;
    background-color: ${COLORS.white};

    ${({ count }) => count === 1 && css`
        grid-template-columns: 1fr;
    `}

    ${({ count }) => count === 2 && css`
        grid-template-columns: 1fr 1fr;
    `}

    ${({ count }) => count === 3 && css`
        grid-template-columns: 60% 40%;
        grid-template-rows: 1fr 1fr;

        & > :nth-child(1) { grid-row: 1 / 3; }
        & > :nth-child(2) { grid-row: 1; }
        & > :nth-child(3) { grid-row: 2; }
    `}

    ${({ count }) => count === 4 && css`
        grid-template-columns: 60% 20% 20%;
        grid-template-rows: 1fr 1fr;

        & > :nth-child(1) { grid-row: 1 / 3; grid-column: 1; }
        & > :nth-child(2) { grid-row: 1; grid-column: 2; }
        & > :nth-child(3) { grid-row: 1; grid-column: 3; }
        & > :nth-child(4) { grid-row: 2; grid-column: 2 / 4; }
    `}

    ${({ count }) => count >= 5 && css`
        grid-template-columns: 60% 20% 20%;
        grid-template-rows: 1fr 1fr;
        & > :first-child { grid-row: 1 / 3; grid-column: 1; }
    `}

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        display: flex;
        gap: 12px;
        height: auto;
        border-radius: 0;
        overflow: visible;
        overflow-x: auto;
        padding-bottom: 0.5rem;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;

        &::-webkit-scrollbar {
            display: none;
        }

        & > * {
            flex: 0 0 85%;
            max-width: 85%;
            height: clamp(220px, 60vw, 360px);
            scroll-snap-align: start;
            border-radius: 16px;
        }
    }
`;

export const GridImage = styled.div`
    position: relative;
    cursor: pointer;
    overflow: hidden;
    border-radius: 12px;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        transition: transform 160ms ease;
    }

    &:hover img {
        transform: scale(1.02);
    }

    &:hover { opacity: 0.95; }
`;

export const ShowAllButton = styled.button`
    position: absolute;
    bottom: 16px;
    right: 16px;
    background: white;
    border: none;
    padding: 8px 16px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);

    &:hover {
        transform: scale(1.05);
    }

    @media (max-width: ${({ theme }) => theme.screenSizes.tablet}) {
        display: none;
    }
`;

// Lightbox Components
export const LightboxOverlay = styled.div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.95);
    z-index: 10000;
    display: flex;
    flex-direction: column;
`;

export const LightboxHeader = styled.div`
    padding: 20px;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 2rem;
    cursor: pointer;
    transition: transform 0.2s;

    &:hover {
        transform: scale(1.1);
    }
`;

export const LightboxBody = styled.div`
    flex: 1;
    position: relative;
    overflow: hidden;
`;

export const CarouselTrack = styled.div`
    display: flex;
    height: 100%;
    transition: transform 300ms ease;
`;

export const CarouselSlide = styled.div`
    flex: 0 0 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        max-width: 90%;
        max-height: 80vh;
        object-fit: contain;
    }
`;

export const ArrowButton = styled.button<{ left?: boolean; right?: boolean }>`
    position: absolute;
    top: 50%;
    ${props => props.left ? 'left: 20px' : 'right: 20px'};
    transform: translateY(-50%);
    background: white;
    border: none;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    font-size: 2rem;
    cursor: pointer;
    z-index: 10;
    transition: background 0.2s;

    &:hover {
        background: rgba(255, 255, 255, 0.9);
    }
`;
